<template>
<div class="chapter">
<div class="inner_page">
<p class="epi-1"><a id="page_vi"></a><a id="page_vii">Eternal Father, strong to save,</a></p><a id="page_vii">
<p class="epi-2">Whose arm hath bound the restless wave,</p>
<p class="epi-2">Who bidd’st the mighty ocean deep</p>
<p class="epi-2">Its own appointed limits keep;</p>
<p class="epi-2">Oh, hear us when we cry to Thee,</p>
<p class="epi-2">For those in peril on the sea!</p>
</a><p class="epi-3"><a id="page_vii">—<span class="txit">Navy Hymn</span></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4145f82d